<script>
import { defineComponent, nextTick } from "vue";
import DeleteConfirmDialog from "@/components/common/dialog/DeleteConfirmDialog";
import LineLinkedDriverSearch from "@/components/management/driver/LineLinkedDriverSearch.vue";
import ApiHandler from "@/mixin/ApiHandler";
import AlertBox from "@/components/common/AlertBox.vue";

export default defineComponent({
  name: "LineLinkLabel",
  components: { AlertBox, LineLinkedDriverSearch, DeleteConfirmDialog },
  mixins: [ApiHandler],
  props: {
    linked: {
      type: Boolean,
      required: true
    },
    lineLink: {
      type: Object,
      required: false,
      default: () => {
        return {
          updatedAt: null
        };
      }
    },
    driverId: {
      type: Number,
      required: false,
      default: null
    }
  },
  methods: {
    formatYmd(dateTimeString) {
      return window.Common.Util.getFullDateTimeIsoFormat(new Date(Date.parse(dateTimeString)));
    },
    openDeleteConfirmDialog() {
      this.$refs.DeleteConfirmDialog.openDialog();
    },
    openLineLinkCopyConfirmDialog() {
      this.$refs.LinkCopyConfirmDialog.openDialog();
    },
    unlinkExecute() {
      this.$store.dispatch("driver/unlinkLineAccount", this.driverId).finally(() => {
        this.$emit("updated");
      });
    },
    linkExecute() {
      this.$store
        .dispatch("driver/linkLineCopyAccount", {
          driverId: this.driverId,
          linedDriverId: this.record.lineLinkedSelectDriver.id
        })
        .then(() => {
          this.$emit("updated");
        })
        .catch(error => {
          if (error.response.data["fieldErrors"]) {
            this.setErrorMessages(error);
          } else {
            this.displayErrorMessage(error.response.data.message);
          }
          return Promise.reject(error);
        });
    },
    selectLinkedDriver(driver) {
      this.record.lineLinkedSelectDriver.id = driver.id;
      this.record.lineLinkedSelectDriver.name = driver.name;
      this.record.lineLinkedSelectDriver.companyName = driver.deliveryCompany.companyNameForDisplay;

      nextTick(() => {
        this.openLineLinkCopyConfirmDialog();
      });
    },
    displayErrorMessage(message) {
      this.$refs.errorMsg.displayMessage(message);
    }
  },
  data() {
    return {
      control: {},
      record: {
        lineLinkedSelectDriver: {
          id: null,
          name: null,
          companyName: null
        }
      }
    };
  }
});
</script>

<template lang="pug">
  v-layout(row wrap)
    DeleteConfirmDialog(ref="DeleteConfirmDialog" @yes="unlinkExecute" title="アカウント連携解除確認" )
      template(v-slot:body)
        div(class="ma-3")
          p LINEとのアカウント連携を解除します。よろしいですか？
    DeleteConfirmDialog(ref="LinkCopyConfirmDialog" @yes="linkExecute" title="アカウント連携複製確認" deleteButtonColor="info" buttonTitle="LINE連携を複製する")
      template(v-slot:body)
        div(class="ma-3")
          p 以下の乗務員が連携済みのLINEアカウントを複製して保存します。よろしいですか？
          div
            v-text-field(v-model="record.lineLinkedSelectDriver.id"  readonly box label="乗務員ID" )
            v-text-field(v-model="record.lineLinkedSelectDriver.name"  readonly box label="乗務員名" )
            v-text-field(v-model="record.lineLinkedSelectDriver.companyName"  readonly box label="所属配送会社" )
    div(v-if="linked").link-label
      v-icon(color="success").icon verified
      v-label LINEアカウント連携済 <br/>({{formatYmd(lineLink.updatedAt)}})
      v-btn(color="error" @click="openDeleteConfirmDialog") アカウント連携解除
    v-flex(v-if="lineLink === null" xs12)
      v-layout(row wrap)
        v-flex(xs12)
          AlertBox(ref="errorMsg" row wrap)
        v-flex(xs12).link-label
          v-icon(color="grey").icon remove_circle_outline
          v-label LINEアカウント未連携
          LineLinkedDriverSearch(@selectItem="selectLinkedDriver"
            :label.sync="record.lineLinkedSelectDriver.name"
            :code.sync="record.lineLinkedSelectDriver.id"
            :errorHandlerMethod="getErrorMessages"
          )


    div(v-if="lineLink !== null && linked === false").link-label
      v-icon(color="warning").icon remove_circle_outline
      v-label LINEアカウント連携失敗 <br/>({{formatYmd(lineLink.updatedAt)}})
      v-btn(color="error" @click="openDeleteConfirmDialog") アカウント連携初期化
</template>

<style scoped lang="stylus">
.link-label
  display flex
  align-items center

  .icon
    margin-right 5px
</style>
